<template>
  <div
    :class="[...rootClasses, bemAdd(isChecked ? 'is-checked' : '')]"
    class="ui-form-field ui-form-field--bool ui-form-field--radio"
  >
    <label>
      <input
        v-bind="$attrs"
        :value="value"
        class="ui-form-field__input"
        type="radio"
        v-on="$listeners"
        @change="onChange"
      />
      <span class="ui-form-field__label-wrap">
        <span class="ui-form-field__box">
          <slot
            :icon-classes="['ui-form-field__box-icon']"
            :icon-classes-base="['ui-form-field__box-icon', 'ui-form-field__box-icon--base']"
            :icon-classes-checked="['ui-form-field__box-icon', 'ui-form-field__box-icon--checked']"
            :is-checked="isChecked"
            name="icon"
          >
            <span class="ui-form-field__box-icon" />
          </slot>
        </span>
        <span v-if="$scopedSlots.label" class="ui-form-field__label">
          <slot name="label" />
        </span>
      </span>
    </label>
    <slot name="messages" />
  </div>
</template>

<script>
  import bemMixin from '@/assets/js/mixin/bem'
  import rootClassesMixin from '@/assets/js/mixin/root-classes'
  import isCheckedMixin from '@/assets/js/mixin/is-checked'
  import hasErrorsPropsMixin from '@/assets/js/mixin/has-error-props'

  export default {
    mixins: [bemMixin('ui-form-field'), rootClassesMixin, isCheckedMixin, hasErrorsPropsMixin],
    props: {
      value: {
        type: String,
        required: true,
      },
    },
  }
</script>
